var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-4"},[_c('div',{staticClass:"pa-3"},[_c('AppTitle',{attrs:{"label":_vm.title}})],1),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }